import script from "./table-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./table-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./table-widget-ly.vue?vue&type=style&index=0&id=5acc9164&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acc9164"]])

export default __exports__